import { MeteringType } from '@enums';
import { Action } from '@ngrx/store';

export enum MeteringPointVirtualGroupActionTypes {
  ActivateVirtualGroup = '[MeteringPoint VirtualGroup] Set',
  SetSelection = '[MeteringPoint VirtualGroup] Set Selection',
  DeactivateVirtualGroup = '[MeteringPoint VirtualGroup] Clear'
}

export class SetSelection implements Action {
  readonly type = MeteringPointVirtualGroupActionTypes.SetSelection;
  constructor(public payload: { meteringPointIds: number[]; meteringType: MeteringType }) {}
}

export class ActivateVirtualGroup implements Action {
  readonly type = MeteringPointVirtualGroupActionTypes.ActivateVirtualGroup;
  constructor(public payload: MeteringType) {}
}

export class DeactivateVirtualGroup implements Action {
  readonly type = MeteringPointVirtualGroupActionTypes.DeactivateVirtualGroup;
  constructor(public payload: MeteringType) {}
}

export type MeteringPointVirtualGroupActions = SetSelection | ActivateVirtualGroup | DeactivateVirtualGroup;
